export default "__VITE_ASSET__BLRvFab4__"